// extracted by mini-css-extract-plugin
export default {"logobox":"App_logobox__fr2yz","title_box":"App_title_box__V050l","box":"App_box__69Fv4","header":"App_header__fhC8n","h3":"App_h3__89GqY","submitButton":"App_submitButton__zlOm0"};